module.exports = __webpack_public_path__ + "img/background1.39522fec.jpg";